import type { SamplingJobMetric } from '../../services/api.types.ts';

export enum SamplingJobChartType {
  Sampler = 1,
  JobStatus = 2,
  SampleType = 3,
  SamplingStatus = 4,
}

export interface SamplingMetricsChartProps {
  className?: string;
  chartType: SamplingJobChartType;
  interactive: boolean;
  data: SamplingJobMetric[];
}
